import Swiper, {Pagination,Grid} from "../../assets/.npm/node_modules/swiper";

export default () => {
  let swiperPartner = new Swiper(".slider-partner", {
    modules: [Pagination,Grid],
    slidesPerView: 2, 
    spaceBetween: 20,
    loop: true,
    grid: {
      rows: 1,
      fill: 'row',
    },
    pagination: {
      el: '.partner-pagination',
      clickable: true,
    },
    breakpoints: {
      580: {
        slidesPerView: 2,
        grid: {
          rows: 1,
          fill: 'row',
        },
      },
      768: {
        slidesPerView: 3,
        grid: {
          rows: 3,
          fill: 'row',
        },
      },
    },
  });
}
  
